import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-copy',
  templateUrl: './info-copy.component.html',
  styleUrls: ['./info-copy.component.scss']
})
export class InfoCopyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
